import { FC } from 'react';
import MasterCardIcon from '@assets/images/partners/masterCard.png';
import useStyles from './styles';

const AmexIcon: FC = (props) => {
  const css = useStyles();

  return (
    <span className={css.container}>
      <img src={MasterCardIcon} {...props} />
    </span>
  );
};

export default AmexIcon;
